import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit,} from "@angular/core";
import {ResultadoRegra} from "../resultado-regra/resultado-regra";
import {MemoriaCalculoService} from "./memoria-calculo.service";
import {StatusRegra} from "../resultado-regra/resultado-regra/status-regra";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DecimalPipe} from "@angular/common";
import {DetalheMemoriaCalculo} from "./detalhe-memoria-calculo";
import {MemoriaCalculo} from "./memoria-calculo";
import {Observable, Subscription} from "rxjs";
import {HttpResponse} from "@angular/common/http";
import {ToastService} from "maps-angular-components";
import {Exporter} from '../shared/export/export';
import {ParametroFuncao} from "../funcao/models/parametro-funcao";
import {MaskUtil} from "../shared/util/mask-util";
import { Funcao } from "../funcao/models/funcao";
import { FuncaoApi } from "../funcao/api/funcao.api";


@Component({
  selector: "app-memoria-calculo",
  templateUrl: "./memoria-calculo.component.html",
  styleUrls: ["./memoria-calculo.component.scss"],
})
export class MemoriaCalculoComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  resultado: ResultadoRegra;

  memoriaCalculo: MemoriaCalculo;
  funcao: Funcao;
  enquadrado: StatusRegra;

  constructor(
    private readonly memoriaCalculoService: MemoriaCalculoService,
    private readonly messageService: ToastService,
    private readonly funcaoService: FuncaoApi,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly decimalPipe: DecimalPipe,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {
  }

  ngOnInit() {
    this.resultado = this.data;
    this.enquadrado = StatusRegra.ENQUADRADA;
    this.subscriptions.add(
      this.funcaoService.buscarFuncao(this.resultado.regra.funcao).subscribe(
        (funcao) => {
          this.funcao = funcao;
          if (this.funcao.parametros) {
            MemoriaCalculoComponent.setMaxLength(this.funcao.parametros);
          }
          this.subscriptions.add(
            this.memoriaCalculoService.search(this.resultado.id).subscribe(
              memorias => {
                this.memoriaCalculo = memorias;

                const parametros = this.memoriaCalculo.regra.parametros;
                if (typeof parametros === 'string') {
                  this.parseParameters(parametros, this.funcao.parametros);
                }
                this.memoriaCalculo.detalhes.forEach(memoria => {
                  memoria.conteudoPaginado.metadata.number = 1;
                });
              },
              err => this.messageService.erro(err.error.message)
            )
          );


        },
        err => this.messageService.erro(err.error.message)
      )
    );
  }

  private parseParameters(parametros: string, parametrosFuncao: ParametroFuncao[]) {
    this.memoriaCalculo.regra.parametros = JSON.parse(parametros);
    this.convertEnumValues();
    this.memoriaCalculo.regra.parametros = this.normalizarParametrosCompostos(this.memoriaCalculo.regra.parametros, parametrosFuncao);
    Object.keys(this.memoriaCalculo.regra.parametros).forEach(paramVar => {
      const param = parametrosFuncao.find(p => p.variavel === paramVar);
      if (param?.tipo === 'CHECKBOX') {
        this.memoriaCalculo.regra.parametros[paramVar] = this.memoriaCalculo.regra.parametros[paramVar].join('/');
      }
    });
  }

  private normalizarParametrosCompostos(parametrosRegra: Record<any, any>, parametrosFuncao: ParametroFuncao[]): Record<any, any> {
    const parametrosRegraNormalizados = {...parametrosRegra};

    parametrosFuncao.filter(p => p.tipo === 'COMPOSTO').forEach(({label, variavel}) => {
      if (parametrosRegraNormalizados[label] !== undefined && label !== variavel) {
        parametrosRegraNormalizados[variavel] = parametrosRegraNormalizados[label];
        delete parametrosRegraNormalizados[label];
      }
    })

    return parametrosRegraNormalizados;
  }

  public formatCnpj(cnpj: string) {
    return MaskUtil.formatCnpj(cnpj);
  }

  private convertEnumValues() {
    if (this.memoriaCalculo.regra.parametros.segmentos) {
      const segmentos = this.memoriaCalculo.regra.parametros.segmentos as string[];
      this.memoriaCalculo.regra.parametros.segmentos = this.toDisplayName(segmentos);
    }
    if (this.memoriaCalculo.regra.parametros.tipoCarteira) {
      const tipoCarteira = this.memoriaCalculo.regra.parametros.tipoCarteira as string[];
      this.memoriaCalculo.regra.parametros.tipoCarteira = this.toTipoCarteiraDisplayName(tipoCarteira).sort();
    }

    if (this.memoriaCalculo.regra.parametros.tipoEmissor) {
      const tipoEmissor = this.memoriaCalculo.regra.parametros.tipoEmissor as string[];
      this.memoriaCalculo.regra.parametros.tipoEmissor = this.toTipoEmissorDisplayName(tipoEmissor).sort();
    }

    if (this.memoriaCalculo.regra.parametros.origem) {
      const origem = this.memoriaCalculo.regra.parametros.origem as string;
      this.memoriaCalculo.regra.parametros.origem = MemoriaCalculoComponent.toOrigemName(origem);
    }
  }

  private static setMaxLength(parametros: ParametroFuncao[]): void {
    parametros.forEach((p) => {
      p.tamanhoMaximoExibicao = 260;
      if (p.parametros) {
        p.parametros.forEach((pc) => {
          pc.tamanhoMaximoExibicao = 260;
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private toTipoCarteiraDisplayName(tipoCarteiras: string[]) {
    return tipoCarteiras.map(tipoCarteira => MemoriaCalculoComponent.getNomeTipoCarteira(tipoCarteira));
  }

  private toTipoEmissorDisplayName(strings: string[]) {
    return strings.map(tipoCarteira => MemoriaCalculoComponent.getNomeTipoEmissor(tipoCarteira));
  }

  changePage(event, memoria: DetalheMemoriaCalculo) {
    memoria.conteudoPaginado.content = memoria.itens[event.page - 1];
    memoria.conteudoPaginado.metadata.number = event.page;
    this.changeDetector.detectChanges();
  }

  isStatusEnquadrada() {
    return this.resultado.status.toLowerCase() === this.enquadrado.name.toLowerCase();
  }

  calculaLinhasTotais(memoria: DetalheMemoriaCalculo) {
    return (
      memoria.conteudoPaginado.metadata.totalElements -
      memoria.quantidadeLinhasTotal
    );
  }

  isEnquadrada(row: any) {
    return row.enquadrado;
  }

  private toDisplayName(segmentos: string[]): string[] {
    return segmentos.map(segmento => MemoriaCalculoComponent.getNomeSegmento(segmento));
  }

  private static getNomeSegmento(segmento: string) {
    if (segmento === 'CAIXA') {
      return 'Caixa';
    }
    if (segmento === 'COTAS') {
      return 'Cotas de fundo';
    }
    if (segmento === 'DERIVATIVOS') {
      return 'Derivativos';
    }
    if (segmento === 'OUTROS') {
      return 'Outros';
    }
    if (segmento === 'RECEBIVEIS') {
      return 'Recebíveis';
    }
    if (segmento === 'RF') {
      return 'Renda fixa';
    }
    if (segmento === 'RV') {
      return 'Renda variável';
    }
    return '';
  }

  private static getNomeTipoCarteira(tipoCarteira: string) {
    if (tipoCarteira === 'CARTEIRA_ADMINISTARADA') {
      return 'Carteira Administrada';
    }
    if (tipoCarteira === 'FUNDO_INVESTIMENTO') {
      return 'Fundo de Investimentos';
    }
    if (tipoCarteira === 'FUNDO_INVESTIMENTO_COTAS') {
      return 'Fundo de Investimentos em Cotas';
    }
    if (tipoCarteira === 'INVESTIDOR_ESTRANGEIRO') {
      return 'Investidor Estrangeiro';
    }
    return '';
  }

  private static getNomeTipoEmissor(tipoCarteira: string) {
    if (tipoCarteira === 'PRIVADO') {
      return 'Privado';
    }
    if (tipoCarteira === 'PUBLICO') {
      return 'Público';
    }
    return '';
  }

  exportPDF(exporter: Exporter) {
    this.doExportPage(this.memoriaCalculoService.getPDFexportData(this.memoriaCalculo), exporter);
  }

  exportXLSX(exporter: Exporter) {
    this.doExportPage(this.memoriaCalculoService.getXLSXexportData(this.memoriaCalculo), exporter);
  }

  doExportPage(observableData: Observable<HttpResponse<Blob>>, exporter: Exporter) {
    this.subscriptions.add(observableData.subscribe(
      (data: HttpResponse<Blob>) => exporter.save(data),
      err => this.messageService.erro(err.error.message)
    ));
  }

  private static toOrigemName(origem: string) {
    if (origem === 'CARTEIRA_PROPRIA') {
      return 'Carteira própria';
    }
    if (origem === 'CARTEIRA_TERCEIROS') {
      return 'Carteira terceiros';
    }
    if (origem === 'CARTEIRA_TOTAL') {
      return 'Carteira total';
    }
    return '';
  }
}
